module.exports = __webpack_public_path__ + "static/media/LTN - GBR Network - 09-05-2024 C.9586eef4.gif";